import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceMid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceMid"><Path d="M9 19H7V5H9V19Z" fill="currentColor"/><Path d="M17 17H15V7H17V17Z" fill="currentColor"/><Path d="M13 15H11V9H13V15Z" fill="currentColor"/><Path d="M5 14H3V10H5V14Z" fill="currentColor"/><Path d="M21 14H19V10H21V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceMid;
